// extracted by mini-css-extract-plugin
module.exports = {"alert-message":"InfoMessage_alert-message__RUQ_P","icon":"InfoMessage_icon__N03hR"};